import request from '@/utils/request'

// 车源信息租赁方案列表
export function getPlanList({
  // 品牌
  brandId,
  // 车系
  seriesId,
  // 方案类型 1 融租；2 经租
  leaseType,
  // 交车城市
  transactionCity,
  // 金融机构 1 厂商金融；2 银行贷款；3 融资租赁公司
  financialInstitution,
  // 租赁模式 1 直租；2 回租
  leaseModel,
  // 还款方式 1 等本等息；2 等额本息
  repaymentMethod,
  pageNum,
  pageSize,
}) {
  return request({
    url: '/admin/v1/vehicle/carResourceCenter/list',
    method: 'POST',
    data: {
      brandId,
      seriesId,
      leaseType,
      transactionCity,
      financialInstitution,
      leaseModel,
      repaymentMethod,
      pageNum,
      pageSize,
    },
  })
}

/**
 * 获取有车源信息的品牌列表
 * @param {*} { leaseType } 方案类型 1 融租；2 经租
 * @returns 品牌列表
 */
export function getCarResourceBrands({ leaseType }) {
  return request({
    url: '/admin/v1/vehicle/carResourceCenter/selectBrand',
    method: 'POST',
    data: { leaseType },
  })
}

/**
 * 获取有车源信息的车系列表
 * @param {*} { brandId } 品牌id
 * @param {*} { leaseType } 方案类型 1 融租；2 经租
 * @returns 车系列表
 */
export function getCarResourceSeries({ brandId, leaseType }) {
  return request({
    url: '/admin/v1/vehicle/carResourceCenter/selectSeries',
    method: 'POST',
    data: { brandId, leaseType },
  })
}


/**
 * 获取租赁方案
 * @param {*} { brandId } 品牌id
 * @param {*} { seriesId } 车系id
 * @param {*} { leaseType } 方案类型 1 融租；2 经租
 * @returns 车系列表
 */
export function getPlans({
  // 品牌
  brandId,
  // 车系
  seriesId,
  // 方案类型
  leaseType,
}) {
  return request({
    url: '/admin/v1/vehicle/carResourceCenter/selectProgrammes',
    method: 'POST',
    data: { brandId, seriesId, leaseType },
  })
}
/**
 * 获取测算schema
 * @param {*} { leaseType } 方案类型 1 融租；2 经租
 * @returns 测算Schema
 */
export function getSchema({ leaseType }) {
  return request({
    url: '/admin/v1/vehicle/carResource/calculation/earnings/getSchema',
    method: 'POST',
    data: { leaseType },
  })
}

/**
 * 盈收测算
 * @param {Object} 租赁车辆数、配置项
 * @returns 预览项
 */
export function calculate({ carNum, programmeList }) {
  return request({
    url: '/admin/v1/vehicle/carResource/calculation/earnings/calculate',
    method: 'POST',
    data: { carNum, programmeList },
  })
}

/**
 * 合作咨询
 * @param {Object} 企业名称、联系人、联系电话、租赁方案id、租赁数量
 * @returns 提交结果
 */
export function cooperate({ enterpriseName, contacts, mobile, programmeId, leaseNumber }) {
  return request({
    url: '/admin/v1/vehicle/carResource/message/add',
    method: 'POST',
    data: { enterpriseName, contacts, mobile, programmeId, leaseNumber },
  })
}


// 信息管理 - 列表
export function infoManageList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResourceManager/list',
    method: 'POST',
    data,
  })
}

// 信息管理 - 删除
export function infoManageDelete(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResourceManager/delete',
    method: 'POST',
    data,
  })
}

// 信息管理 - 发布 - 编辑时
export function infoManagePublishEdit(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResourceManager/edit',
    method: 'POST',
    data,
  })
}
// 信息管理 - 发布 - 新增时
export function infoManagePublishAdd(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResourceManager/release',
    method: 'POST',
    data,
  })
}

// 信息管理 - 详情
export function infoManageDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResourceCenter/detail',
    method: 'POST',
    data,
  })
}

// 信息管理 - 计算内部收益率
export function infoManageIrr(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResource/calculation/irr/calculate',
    method: 'POST',
    data,
  })
}

// 商机管理 - 列表
export function businessManageList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResource/message/page',
    method: 'POST',
    data,
  })
}

// 商机管理 - 详情
export function businessManageDetail(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResource/message/detail',
    method: 'POST',
    data,
  })
}

// 商机管理 - 跟进
export function businessManageFollow(data = {}) {
  return request({
    url: '/admin/v1/vehicle/carResource/message/follow/add',
    method: 'POST',
    data,
  })
}
